import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Navbar,
  Nav as NavRB,
  NavItem,
  NavDropdown,
  MenuItem,
} from 'react-bootstrap';
import i18n from '../../../config/i18n';
import StyledToggle from './StyledToggle';
import StyledBrand from './StyledBrand';
import StyledNavbar from './StyledNavbar';
import { ADMIN_ID } from '../../../constants/RoleConstants';

export default class Nav extends Component {
  static propTypes = {
    roleId: PropTypes.number,
    isLoggedIn: PropTypes.bool,
    changeLang: PropTypes.func.isRequired,
    currentTeamId: PropTypes.number,
    changeTeam: PropTypes.func.isRequired,
    teamList: PropTypes.arrayOf(PropTypes.object),
    getTeamList: PropTypes.func.isRequired,
  };

  static defaultProps = {
    roleId: undefined,
    isLoggedIn: false,
    currentTeamId: 0,
    teamList: [],
  };

  render() {
    const {
      roleId,
      isLoggedIn,
      // changeLang,
      currentTeamId,
      changeTeam,
      teamList,
      getTeamList,
    } = this.props;
    return (
      <StyledNavbar fixedTop>
        <Navbar.Header>
          <StyledBrand />
          <StyledToggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <NavRB pullRight>
            <NavItem href="/subscription" >
              {i18n.t('pricing')}
            </NavItem>
            {
              !isLoggedIn && (
                <NavItem href="login" >
                  {i18n.t('login')}
                </NavItem>
              )
            }
            {
              isLoggedIn && roleId !== ADMIN_ID && (
                <NavDropdown
                  id="i18nNavDropdown"
                  title={i18n.t('teamListTitle')}
                  onSelect={teamId => changeTeam(teamId)}
                  onClick={getTeamList}
                >
                  {
                    teamList.length
                      ? (teamList.map(team => (
                        <MenuItem
                          key={team.name}
                          eventKey={team.id}

                          /**
                           * If we use the property 'active' to highlight the selected item,
                           * the background color of the dropdown will be strange (be highlighted).
                           * Be supposed to refactor this component by Ant Design in the future.
                           */
                          disabled={team.id === currentTeamId}
                        >
                          {team.name}
                        </MenuItem>
                      )))
                      : (
                        <MenuItem
                          disabled
                        >
                          No team
                        </MenuItem>
                      )
                  }
                </NavDropdown>
              )
            }
            {/* FIXME: Disable this feature for the demo purposes. */}
            {/* <NavDropdown */}
            {/*  id="i18nNavDropdown" */}
            {/*  title={i18n.t('lang')} */}
            {/*  onSelect={lang => changeLang(lang)} */}
            {/* > */}
            {/*  { */}
            {/*    Object.keys(i18n.translations).map(lang => ( */}
            {/*      <MenuItem */}
            {/*        key={lang} */}
            {/*        eventKey={lang} */}
            {/*        disabled={lang === i18n.locale} */}
            {/*      > */}
            {/*        {i18n.t(lang)} */}
            {/*      </MenuItem> */}
            {/*    )) */}
            {/*  } */}
            {/* </NavDropdown> */}
          </NavRB>
        </Navbar.Collapse>
      </StyledNavbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Nav/index.js